import requests from '@/utils/requests';

/**
 *  创建测试报告
 * @param {*} data
 */
export function addTestReport(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testReport/add',
    method: 'post',
    data
  });
}

/**
 *  获取测试报告详情
 * @param {*} data
 */
export function getReportDetail(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testReport/detail',
    method: 'post',
    data
  });
}

/**
 *  更新测试报告
 * @param {*} data
 */
export function updateTestReport(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testReport/update',
    method: 'post',
    data
  });
}

/**
 *  发送测试报告
 * @param {*} data
 */
export function sendTestReport(data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/testReport/sendTestReport',
    method: 'post',
    data
  });
}
